import { defineStore } from "pinia";

export const useMessageStore = defineStore("message", () => {
  const messages = reactive([]);
  let nextId = 0;

  function push(message) {
    messages.push({ id: nextId++, ...message });
  }
  function remove(id) {
    const index = messages.findIndex((m) => m.id === id);
    if (index !== -1) messages.splice(index, 1);
  }
  function success(message) {
    push({ type: "success", message, timeout: 4000 });
  }
  function error(message) {
    push({ type: "error", message });
  }
  function warning(message) {
    push({ type: "warning", message });
  }
  function info(message) {
    push({ type: "info", message, timeout: 6000 });
  }
  function i18nMessage(type, key, params, timeout) {
    push({ type, key, params, timeout });
  }
  function customMessage(type, message, timeout) {
    push({ type, message, timeout });
  }
  return { messages, remove, success, error, warning, info, i18nMessage, customMessage };
});
